"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdvancedSelectControl = void 0;
const react_1 = __importStar(require("react"));
const react_select_1 = __importDefault(require("react-select"));
const Creatable_1 = __importDefault(require("react-select/lib/Creatable"));
const core_1 = require("@material-ui/core");
const classnames_1 = __importDefault(require("classnames"));
const assign_1 = __importDefault(require("lodash/assign"));
const find_1 = __importDefault(require("lodash/find"));
const get_1 = __importDefault(require("lodash/get"));
const isString_1 = __importDefault(require("lodash/isString"));
const noop_1 = __importDefault(require("lodash/noop"));
const prop_types_1 = __importDefault(require("prop-types"));
const utils_1 = require("../../utils/utils");
const animated_overflow_list_item_text_1 = __importDefault(require("../material-list/animated-overflow-list-item-text"));
const async_dropdown_1 = __importDefault(require("../react-select/async-dropdown/async-dropdown"));
const async_static_list_selector_1 = __importDefault(require("../react-select/async-dropdown/async-static-list-selector"));
const default_dropdown_1 = __importDefault(require("../react-select/default-dropdown/default-dropdown"));
const select_components_1 = require("../react-select/select-components");
const select_with_dynamic_width_1 = __importDefault(require("../react-select/select-with-dynamic-width/select-with-dynamic-width"));
const tooltip_1 = __importDefault(require("../tooltip/tooltip"));
const typography_1 = __importDefault(require("../typography/typography"));
const advanced_select_utils_1 = require("./advanced-select-utils");
require("../../styles/components/advanced-select.less");
const ANIMATE_PIXELS_PER_SECOND = 40;
const inputComponent = ({ inputRef, ...props }) => (react_1.default.createElement("div", { ref: inputRef, ...props }));
const AdvancedSelectControl = (props) => {
    const { selectProps, innerRef, children, innerProps, isFocused, hasValue } = props;
    const { label, placeholder, required, errorType, error, helperText, value, forceShrinkLabel } = selectProps;
    const { style = {} } = value || {};
    const [showTooltip, setShowTooltip] = (0, react_1.useState)(false);
    const textFieldRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        if (textFieldRef && textFieldRef.current) {
            const el = textFieldRef.current.getElementsByClassName('react-select-dropdown__single-value')[0];
            setShowTooltip(el && (0, utils_1.isEllipsisActive)(el));
        }
    }, [value]);
    return (react_1.default.createElement(tooltip_1.default, { title: showTooltip && value ? value.label : '' },
        react_1.default.createElement(core_1.TextField, { ref: textFieldRef, disabled: selectProps.disabled || selectProps.isDisabled, className: "select-text-field react-select-dropdown__control", InputProps: {
                classes: { input: 'selector-control-input' },
                inputComponent,
                className: 'select-text-container',
                style: { height: selectProps.height || 'auto', minHeight: selectProps.height || 40 },
                inputProps: {
                    style: { display: 'flex', padding: 0, height: selectProps.height || 'auto', zIndex: 1, ...style },
                    inputRef: innerRef,
                    children,
                    ...innerProps,
                },
            }, InputLabelProps: {
                shrink: !!label && (!!hasValue || isFocused || forceShrinkLabel),
                required,
            }, label: (hasValue || !placeholder || forceShrinkLabel) ? label : '', variant: selectProps.variant || 'outlined', fullWidth: !!selectProps.fullWidth, ...(0, advanced_select_utils_1.helperTextProps)(error, errorType, helperText) })));
};
exports.AdvancedSelectControl = AdvancedSelectControl;
const Option = (props) => {
    const { innerRef, isFocused, innerProps: { onMouseMove, onMouseOver, ...otherInnerProps }, selectProps: { optionClassName }, children, data, selectOption, label } = props;
    const newInnerProps = (0, assign_1.default)({}, otherInnerProps);
    if (data.isAddOption) {
        return (react_1.default.createElement("div", { className: "add-option option-container", onClick: () => selectOption(data) },
            react_1.default.createElement(typography_1.default, { component: "div", variant: "body2", className: "option-wrapper" }, `+ ${label}`)));
    }
    return (react_1.default.createElement(core_1.MenuItem, { classes: { root: (0, classnames_1.default)('advanced-select-option', optionClassName) }, buttonRef: innerRef, selected: isFocused, component: "div", style: data.style || {}, ...newInnerProps },
        data.icon ? react_1.default.createElement("i", { className: `${data.icon} advanced-select-icon` }) : null,
        data.iconComponent ? data.iconComponent : null,
        children));
};
const defaultComponents = {
    Control: exports.AdvancedSelectControl,
    Option,
    MenuList: select_components_1.MenuList,
    DropdownIndicator: select_components_1.DropdownIndicator,
};
const createLabel = (newLabel) => `${newLabel} (new)`;
const Z_INDEX_SHOW_ON_TOP = 1499;
const EMPTY_OPTIONS_TEXT = 'Not Selected';
const EMPTY_OPTIONS = {
    value: null,
    label: react_1.default.createElement("div", { style: { opacity: 0.5 } }, EMPTY_OPTIONS_TEXT),
};
const AdvancedSelect = (0, react_1.forwardRef)((props, ref) => {
    const { className = '', onChange, async, loadOptions, selected, disabled, components, isCreatable, options, addOptions, isSearchable, maxItemsToRender, menuPortalTarget, showOnTop, classNamePrefix, styles, asyncStaticList, animateOverflow, useDynamicWidth, showEmpty, noAutoComplete, formatCreateLabel = createLabel, ...restProps } = props;
    const styleComponents = (0, react_1.useMemo)(() => ({
        ...defaultComponents,
        ...noAutoComplete && { Input: select_components_1.NoAutoCompleteInput },
        ...components,
    }), [noAutoComplete, components]);
    const allOptions = (0, react_1.useMemo)(() => {
        if (animateOverflow) {
            const optionsWithAnimationOverflow = options?.map((option) => ({
                ...option,
                label: react_1.default.createElement(animated_overflow_list_item_text_1.default, { primary: option.label, pixelsPerSecond: ANIMATE_PIXELS_PER_SECOND }),
            }));
            return addOptions.map((option) => ({ ...option, isAddOption: true })).concat(optionsWithAnimationOverflow || []).concat(showEmpty ? EMPTY_OPTIONS : []);
        }
        return addOptions.map((option) => ({ ...option, isAddOption: true })).concat(options || []).concat(showEmpty ? EMPTY_OPTIONS : []);
    }, [addOptions, animateOverflow, options, showEmpty]);
    const onChangeWithOverflowAnimation = (0, react_1.useCallback)((option) => {
        // in case of overflow animation, we want to return the label string instead of the AnimateOverflowListItemText component
        const newOption = options.find((o) => o.value === option.value);
        onChange(newOption);
    }, [onChange, options]);
    const newProps = (0, react_1.useMemo)(() => ({
        components: styleComponents,
        onChange: animateOverflow ? onChangeWithOverflowAnimation : onChange,
        options: allOptions,
        classNamePrefix,
        styles: showOnTop ? {
            ...styles,
            menuPortal: (base) => {
                const result = {
                    ...base,
                    ...(0, get_1.default)(styles, 'menuPortal', noop_1.default)(base),
                    zIndex: Z_INDEX_SHOW_ON_TOP,
                };
                // when window is scrolled via `X` axis - appeared menu is shifted, below is the fix for it
                result.left += window.scrollX;
                return result;
            },
        } : styles,
        menuPortalTarget: showOnTop ? document.body : menuPortalTarget,
        value: (0, isString_1.default)(selected) ? (0, find_1.default)(allOptions, { value: selected }) : selected,
        isDisabled: disabled,
        isCreatable,
        isSearchable: allOptions.length > maxItemsToRender ? true : isSearchable,
        formatCreateLabel,
        menuPlacement: 'auto',
        maxItemsToRender,
    }), [styleComponents, animateOverflow, onChangeWithOverflowAnimation, onChange, allOptions, classNamePrefix, showOnTop, styles, menuPortalTarget, selected, disabled, isCreatable, maxItemsToRender, isSearchable, formatCreateLabel]);
    const classNames = `select react-select-dropdown-container ${className}`;
    if (asyncStaticList) {
        return (react_1.default.createElement(async_static_list_selector_1.default, { className: `${classNames} async`, ...newProps, ...restProps }));
    }
    if (async) {
        return (react_1.default.createElement(async_dropdown_1.default, { className: `${classNames} async`, asyncFunc: loadOptions, ...newProps, ...restProps }));
    }
    if (isCreatable) {
        return (react_1.default.createElement(Creatable_1.default, { ref: ref, className: `${classNames} creatable`, ...newProps, ...restProps }));
    }
    if (useDynamicWidth) {
        return (react_1.default.createElement(select_with_dynamic_width_1.default, { className: classNames, ...newProps, ...restProps }));
    }
    return (react_1.default.createElement(react_select_1.default, { ref: ref, className: classNames, ...newProps, ...restProps }));
});
AdvancedSelect.defaultProps = {
    className: '',
    components: {},
    disabled: false,
    loadOptions: undefined,
    onChange: noop_1.default,
    async: false,
    isMulti: false,
    selected: undefined,
    classNamePrefix: 'react-select-dropdown',
    showOnTop: false,
    asyncStaticList: undefined,
    maxItemsToRender: 300,
    animateOverflow: false,
    useDynamicWidth: false,
    options: undefined,
    addOptions: [],
    noAutoComplete: false,
};
AdvancedSelect.propTypes = {
    className: prop_types_1.default.string,
    onChange: prop_types_1.default.func,
    async: prop_types_1.default.bool,
    asyncStaticList: prop_types_1.default.array,
    loadOptions: prop_types_1.default.func,
    selected: default_dropdown_1.default.propTypes.selected,
    disabled: prop_types_1.default.bool,
    classNamePrefix: prop_types_1.default.string,
    components: prop_types_1.default.object,
    isMulti: prop_types_1.default.bool,
    showOnTop: prop_types_1.default.bool,
    maxItemsToRender: prop_types_1.default.number,
    animateOverflow: prop_types_1.default.bool,
    useDynamicWidth: prop_types_1.default.bool,
    options: prop_types_1.default.array,
    addOptions: prop_types_1.default.array,
    noAutoComplete: prop_types_1.default.bool,
};
exports.default = AdvancedSelect;
//# sourceMappingURL=advanced-select.js.map